module.exports = __webpack_public_path__ + "img/b96777aa923b9573f6143eaaf0beaf7f48611e96.a7eb68b3.png";